<script setup>
import { AvatarFallback } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  delayMs: { type: Number, default: undefined },
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <AvatarFallback
    data-slot="avatar-fallback"
    :delay-ms="delayMs"
    :class="
      cn(
        'flex size-full items-center justify-center rounded-full bg-muted text-muted-foreground text-xs font-medium',
        props.class
      )
    "
  >
    <slot />
  </AvatarFallback>
</template>
